import { Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import {
  Dimensions,
  Image,
  Linking,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import flash from "config/flash"
import { colors } from "colors"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import moment from "moment"
import RenderHTML from "react-native-render-html"
import { typography } from "theme"
import { useColor } from "app/theme/getThemes"

export const PromotionDetailScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()
  const route = useRoute<any>()

  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  const [isTncOpen, setIsTncOpen] = useState(false)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [promotion, setPromotion] = useState<any>([])
  const [loading, setLoading] = useState(false)

  const maxWidth = 800
  const screenWidth = Dimensions.get("screen").width
  const imageWidth = Math.min(screenWidth, maxWidth)
  const aspectRatio = 1920 / 1080

  useEffect(() => {
    setLoading(true)
    getPromotion()
  }, [route])

  console.log(route?.params?.promotion_id)

  const getPromotion = async () => {
    await fetch(`${process.env.API_URL}/api/promotion/${route?.params?.promotion_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPromotion(responseData[0])
          setLoading(false)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
            setLoading(false)
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
            navigation.reset({ index: 0, routes: [{ name: "app" }] })
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        navigation.reset({ index: 0, routes: [{ name: "app" }] })
        console.error(e)
      })
  }

  const Accordion = ({ type }: { type: "redeem" | "tnc" }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen
    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>
            {type === "redeem"
              ? translate("promotionDetailScreen.howToRedeem")
              : translate("promotionDetailScreen.tnc")}
          </Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={companyTheme.first} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={companyTheme.first} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <View>
            <View style={style.accordionContentContainer} />
            <RenderHTML
              source={{
                html: promotion?.promotion_tnc,
              }}
            />
          </View>
        )}
      </View>
    )
  }

  return (
    <>
      <Screen preset="scroll">
        <View>
          <View>
            {promotion?.promotion_url ? (
              <TouchableOpacity
                onPress={() => {
                  if (promotion?.promotion_url) {
                    let url = promotion.promotion_url
                    if (!url.startsWith("http://") && !url.startsWith("https://")) {
                      url = "https://" + url // default to HTTPS
                    }

                    Linking.openURL(url).catch(() => {
                      flash("error", "Unable to open link")
                    })
                  }
                }}
              >
                <Image
                  source={{ uri: promotion?.promotion_banner }}
                  resizeMode="contain"
                  style={[
                    style.image,
                    {
                      width: imageWidth,
                      height: imageWidth / aspectRatio,
                    },
                  ]}
                />
              </TouchableOpacity>
            ) : (
              <View>
                <Image
                  source={{ uri: promotion?.promotion_banner }}
                  resizeMode="contain"
                  style={[
                    style.image,
                    {
                      width: imageWidth,
                      height: imageWidth / aspectRatio,
                    },
                  ]}
                />
              </View>
            )}
            <TouchableOpacity
              onPress={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack()
                } else {
                  navigation.reset({ index: 0, routes: [{ name: "app" }] })
                }
              }}
              style={style.headerLeftButton}
            >
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
            {/* <TouchableOpacity onPress={onShare} style={style.headerRightButton}>
              <Icon name="share" size={28} color="white" />
            </TouchableOpacity> */}
          </View>
          <View style={style.container}>
            {/* <View
              style={[
                style.tagContainer,
                // eslint-disable-next-line react-native/no-inline-styles, react-native/no-color-literals
                {
                  backgroundColor: data?.tag === "Voucher" ? "#FF1B5F" : "#9271F0",
                },
              ]}
            >
              <Text style={style.tagText}>{data?.tag}</Text>
            </View> */}
            <Text style={style.title}>{promotion?.promotion_name}</Text>

            {promotion?.promotion_url && (
              <TouchableOpacity
                style={[style.calendarContainer, { marginBottom: 10 }]}
                onPress={() => {
                  if (promotion?.promotion_url) {
                    let url = promotion.promotion_url
                    if (!url.startsWith("http://") && !url.startsWith("https://")) {
                      url = "https://" + url // default to HTTPS
                    }

                    Linking.openURL(url).catch(() => {
                      flash("error", "Unable to open link")
                    })
                  }
                }}
              >
                <MaterialCommunityIcons name="web" size={28} color={companyTheme.first} />
                <Text style={(style.dateText, { color: companyTheme.first, marginLeft: 5 })}>
                  {promotion?.promotion_url}
                </Text>
              </TouchableOpacity>
            )}

            {promotion?.show_datetime === true && (
              <View style={style.calendarContainer}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />
                <Text style={style.dateText}>
                  {moment(promotion?.start_at).format("DD-MMM-YYYY")} -{" "}
                  {promotion?.end_at === null
                    ? "Until Further Notice"
                    : moment(promotion?.end_at).format("DD-MMM-YYYY")}
                </Text>
              </View>
            )}

            <RenderHTML
              defaultTextProps={{
                style: {
                  fontFamily: typography.primary.normal,
                },
              }}
              source={{
                html: promotion?.promotion_description,
              }}
              tagsStyles={{
                p: {
                  marginTop: 0,
                  marginBottom: 0,
                },
              }}
            />

            {/* Accordian dropdown */}

            {/* {data?.tag === "Voucher" && <Accordion type="redeem" />} */}
            <Accordion type="tnc" />
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>
      {/* <View style={style.stickyBottomContainer}>
        <Button
          title={translate("promotionDetailScreen.claimVoucher")}
          style={style.buttonContainer}
          titleStyle={style.buttonText}
        />
      </View> */}
    </>
  )
}
